import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MetricGraphScreen from './metric-graph-screen-model'
import {
  CreateMetricGraphScreenAsync,
  DeleteMetricGraphScreenAsync,
  LoadMetricGraphScreensAsync,
} from './metricGraphScreen-thunk'
const initialState: metricGraphScreenSliceState = {
  metricGraphScreen: [],
  selected_metricGraphScreen: '',
  is_loading_metricGraphScreen: false,
  is_creating_metricGraphScreen: false,
  is_deleting_metricGraphScreen: false,
}
export interface metricGraphScreenSliceState {
  metricGraphScreen: MetricGraphScreen[]
  selected_metricGraphScreen?: string
  is_loading_metricGraphScreen: boolean
  is_creating_metricGraphScreen: boolean
  is_deleting_metricGraphScreen: boolean
}
export const metricGraphScreenSlice = createSlice({
  name: 'metricGraphScreen',
  initialState,
  reducers: {
    setSelectedmetricGraphScreen: (state, action) => {
      state.selected_metricGraphScreen = action.payload
    },
    clearStatemetricGraphScreen: (state) => {
      state.metricGraphScreen = []
      state.is_loading_metricGraphScreen = false
      state.is_creating_metricGraphScreen = false
      state.is_deleting_metricGraphScreen = false
    },
    mergemetricGraphScreen: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricGraphScreen = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricGraphScreen = merge(
            state.metricGraphScreen,
            payload,
          ) as any
        }
      }
    },

    add_metricGraphScreen: (state, action) => {
      if (action.payload) {
        state.metricGraphScreen = [...state.metricGraphScreen, action.payload]
      }
    },
    set_metricGraphScreen: (state, action) => {
      let { key, value, id } = action.payload
      state.metricGraphScreen = state.metricGraphScreen.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricGraphScreensAsync.pending, (state) => {
      state.is_loading_metricGraphScreen = true
    })
    builder.addCase(LoadMetricGraphScreensAsync.fulfilled, (state, action) => {
      state.is_loading_metricGraphScreen = false
      if (action.payload) {
        state.metricGraphScreen = action.payload
      }
    })
    builder.addCase(LoadMetricGraphScreensAsync.rejected, (state) => {
      state.is_loading_metricGraphScreen = false
    })
    builder.addCase(CreateMetricGraphScreenAsync.pending, (state) => {
      state.is_creating_metricGraphScreen = true
    })
    builder.addCase(CreateMetricGraphScreenAsync.fulfilled, (state) => {
      state.is_creating_metricGraphScreen = false
    })
    builder.addCase(CreateMetricGraphScreenAsync.rejected, (state) => {
      state.is_creating_metricGraphScreen = false
    })
    builder.addCase(DeleteMetricGraphScreenAsync.pending, (state) => {
      state.is_deleting_metricGraphScreen = true
    })
    builder.addCase(DeleteMetricGraphScreenAsync.fulfilled, (state, action) => {
      state.is_deleting_metricGraphScreen = false
      if (state.metricGraphScreen) {
        state.metricGraphScreen = state.metricGraphScreen.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMetricGraphScreenAsync.rejected, (state) => {
      state.is_deleting_metricGraphScreen = false
    })

    builder.addCase(autoThunks.load_metric_graph_screens.pending, (state) => {
      state.is_loading_metricGraphScreen = true
    })
    builder.addCase(
      autoThunks.load_metric_graph_screens.fulfilled,
      (state, action) => {
        state.is_loading_metricGraphScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_metric_graph_screens.rejected, (state) => {
      state.is_loading_metricGraphScreen = false
    })

    builder.addCase(autoThunks.store_metric_graph_screen.pending, (state) => {
      state.is_loading_metricGraphScreen = true
    })
    builder.addCase(
      autoThunks.store_metric_graph_screen.fulfilled,
      (state, action) => {
        state.is_loading_metricGraphScreen = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.store_metric_graph_screen.rejected, (state) => {
      state.is_loading_metricGraphScreen = false
    })
  },
})

function handleResult(action: any, state: metricGraphScreenSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_metricGraphScreen = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.metricGraphScreen = merge(state.metricGraphScreen, payload) as any
    }
  }
}

export const {
  clearStatemetricGraphScreen,
  setSelectedmetricGraphScreen,
  set_metricGraphScreen,
  mergemetricGraphScreen,
  add_metricGraphScreen,
} = metricGraphScreenSlice.actions

export const get_metricGraphScreen =
  (id?: string) =>
  (state: {
    metricGraphScreen: {
      metricGraphScreen: MetricGraphScreen[]
    }
  }): MetricGraphScreen | null => {
    let temp = state?.metricGraphScreen?.metricGraphScreen?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.metricGraphScreen?.metricGraphScreen[0] || null
  }
export const get_selected_metricGraphScreen = (state: {
  metricGraphScreen: metricGraphScreenSliceState
}): MetricGraphScreen | null => {
  let id = state?.metricGraphScreen?.selected_metricGraphScreen
  let temp = state?.metricGraphScreen?.metricGraphScreen?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricGraphScreen = (state: {
  metricGraphScreen: {
    metricGraphScreen: MetricGraphScreen[]
  }
}): MetricGraphScreen[] => {
  let temp = state?.metricGraphScreen?.metricGraphScreen
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricGraphScreen_busy = (state: {
  metricGraphScreen: metricGraphScreenSliceState
}) => {
  return (
    state?.metricGraphScreen.is_deleting_metricGraphScreen ||
    state?.metricGraphScreen.is_loading_metricGraphScreen ||
    state?.metricGraphScreen.is_creating_metricGraphScreen
  )
}
export const is_deleting_metricGraphScreen_busy = (state: {
  metricGraphScreen: metricGraphScreenSliceState
}) => {
  return state?.metricGraphScreen.is_deleting_metricGraphScreen
}
export const is_loading_metricGraphScreen_busy = (state: {
  metricGraphScreen: metricGraphScreenSliceState
}) => {
  return state?.metricGraphScreen.is_loading_metricGraphScreen
}
export const is_creating_metricGraphScreen_busy = (state: {
  metricGraphScreen: metricGraphScreenSliceState
}) => {
  return state?.metricGraphScreen.is_creating_metricGraphScreen
}

export default metricGraphScreenSlice.reducer
